import React, { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CardsBrowse } from '../../components/CardsBrowse';
import { CardsContext } from "../../CardsContext";
import { capitalizeFirstLetter, sendPageViewEvent } from '../../../../utils/utils';

export function HomePage({
  browseCards,
  onToggleWatchLater,
  onSeeAll
}) {
  const { target, isTargetClasses, cardsConfig } = useContext(CardsContext);
  const [current, setCurrent] = useState(1);

  useEffect(() => {
    sendPageViewEvent(`Poker Coaching ${target} | PokerCoaching.com`);
    const element = document.querySelector(`[data-screen="${target}"]`);
    const pageTitle = element?.getAttribute("data-pagetitle") || `${capitalizeFirstLetter(target)} – PokerCoaching.com`;
  
    document.title = pageTitle;
  }, [target]);

  if(!browseCards?.length) {
    return <p className="no-data">No {target}</p>;
  }

  const visibleBrowseCards = browseCards.slice(0, current * 10);

  return (
    <InfiniteScroll
      dataLength={visibleBrowseCards.length}
      next={() => setCurrent((prevCurrent) => prevCurrent + 1)}
      hasMore={visibleBrowseCards.length < browseCards.length}
      loader={<h4>Loading...</h4>}
      endMessage={null}
      style={{ overflow: 'visible' }}
      scrollThreshold={0.5}
    >
      {visibleBrowseCards.map((browseItem) => (
        <CardsBrowse
          isShowDate={isTargetClasses}
          isShowWatchLater={cardsConfig.watchLater}
          type={target}
          browseItem={browseItem}
          counter={browseItem.counter}
          limit={browseItem.limit}
          key={browseItem.title}
          onToggleWatchLater={onToggleWatchLater}
          onSeeAll={browseItem.onSeeAll || onSeeAll}
        />
      ))}
    </InfiniteScroll>
  );
}
